// extracted by mini-css-extract-plugin
export default {"form":"styles_form__caurU","surveyHeading":"styles_surveyHeading__q0xay","input":"styles_input__qbZeC"};